import React, { useState } from 'react';
import { mediaContainerStyles, mediaLoadingContainerStyles, mediaStyles } from '../../styles/commonStyles';
import Spinner from '../Spinner';

/**
 * Компонент для отображения превью медиафайлов (изображений и видео)
 * @param {Object} props - Свойства компонента
 * @param {Object} props.media - Объект с данными медиафайла
 * @param {string} props.media.cloud_url - URL медиафайла
 * @returns {JSX.Element} Компонент превью медиафайла
 */
const MediaPreview = ({ media }) => {
  const [mediaLoaded, setMediaLoaded] = useState(false);

  if (!media) return null;

  // Поддержка media.cloud_url и media.url
  const url = media.cloud_url || media.url;

  if (!url) {
    return (
      <div className={mediaContainerStyles}>
        <div className="text-red-500 text-center p-4">
          Нет связи с облачным хранилищем. Файл сохранен локально.
        </div>
      </div>
    );
  }

  const isVideo = url.toLowerCase().endsWith('.mp4');

  return (
    <div className={mediaContainerStyles}>
      {!mediaLoaded && (
        <div className={mediaLoadingContainerStyles}>
          <Spinner />
        </div>
      )}
      {isVideo ? (
        <video
          src={url}
          muted
          loop
          autoPlay
          className={mediaStyles(mediaLoaded)}
          onLoadedData={() => setMediaLoaded(true)}
        />
      ) : (
        <img
          src={url}
          alt="Uploaded"
          className={mediaStyles(mediaLoaded)}
          onLoad={() => setMediaLoaded(true)}
        />
      )}
    </div>
  );
};

export default MediaPreview; 